import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {WorkflowCrudComponent} from '../components/workflow-crud.component';

/** Delegates route departure checks to the workflow editor. */
@Injectable()
export class WorkflowUnsavedGuard implements CanDeactivate<WorkflowCrudComponent> {
  /** Keeps the current route until unsaved changes have been acknowledged. */
  public canDeactivate(component: WorkflowCrudComponent): Promise<boolean> {
    return component.canDeactivate();
  }
}
